export default __webpack_public_path__ + "static/media/Continental_Original.a81b400a.png";